(function (window, angular, undefined) {
    angular.module('formApp')
        .directive('preventmousewheel', [function ($scope) {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, c) {
                    elm.bind('wheel', function (event) {
                        this.blur();
                    });
                    elm.bind('mousewheel', function (event) {
                        this.blur();
                    });
                }
            };
        }]);
})(window, window.angular);